import { useState, useEffect } from 'react';

type ServiceUsage = {
    [key: string]: number;
};

export const useEligibilityLimit = (serviceName?: string) => {
    const [canAccess, setCanAccess] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        checkAccess();
    }, [serviceName]);

    const checkAccess = () => {
        // 1. Check if logged in (Token exists) -> Unlimited Access
        const token = localStorage.getItem('token');
        if (token) {
            setCanAccess(true);
            setLoading(false);
            return;
        }

        // 2. Check if Guest has already used the tool
        const usageData = localStorage.getItem('guest_eligibility_usage_data');
        if (usageData && serviceName) {
            try {
                const usage: ServiceUsage = JSON.parse(usageData);
                const count = usage[serviceName] || 0;
                if (count >= 2) {
                    setCanAccess(false);
                } else {
                    setCanAccess(true);
                }
            } catch (e) {
                console.error("Failed to parse usage data", e);
                setCanAccess(true);
            }
        } else {
            setCanAccess(true);
        }
        setLoading(false);
    };

    const markAsUsed = () => {
        // Only increment if not logged in
        const token = localStorage.getItem('token');
        if (!token && serviceName) {
            const usageData = localStorage.getItem('guest_eligibility_usage_data');
            let usage: ServiceUsage = {};
            if (usageData) {
                try {
                    usage = JSON.parse(usageData);
                } catch (e) {
                    console.error("Failed to parse usage data", e);
                }
            }

            const currentCount = usage[serviceName] || 0;
            usage[serviceName] = currentCount + 1;

            localStorage.setItem('guest_eligibility_usage_data', JSON.stringify(usage));

            if (usage[serviceName] >= 2) {
                setCanAccess(false);
            }
        }
    };

    return { canAccess, loading, markAsUsed };
};
